.checkbox {
  accent-color: var(--color-uva-black);
  height: 1rem;
  margin: 0;
  padding: 0;
  width: 1rem;
}
